var map = {
	"./ball.png": 7606,
	"./casino-chip.png": 7557,
	"./fish.png": 8819,
	"./home.png": 4584,
	"./lotto.png": 143,
	"./nav-menu-login.svg": 3346,
	"./nav-menu-promotion.svg": 378,
	"./nav-menu-register.svg": 7212,
	"./nav-menu-support.svg": 4452,
	"./slot-machine.png": 7233,
	"./หน้าแรก.png": 2715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;